import React from 'react';
import { Box, Typography } from '@mui/material';
import type { CommunityMessageLinkPreview } from '../../services/communityService';

interface Props {
  preview: CommunityMessageLinkPreview;
  onClick?: (e: React.MouseEvent) => void;
}

export const LinkPreviewCard: React.FC<Props> = ({ preview, onClick }) => {
  const hostname = (() => {
    try {
      return new URL(preview.url).hostname.replace(/^www\./, '');
    } catch {
      return preview.site_name || preview.url;
    }
  })();

  return (
    <Box
      component="a"
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      sx={{
        display: 'block',
        mt: 0.75,
        borderRadius: 1,
        overflow: 'hidden',
        border: '1px solid rgba(0,0,0,0.08)',
        bgcolor: 'rgba(255,255,255,0.6)',
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      {preview.image_url && (
        <Box
          component="img"
          src={preview.image_url}
          alt=""
          sx={{ width: '100%', maxHeight: 160, objectFit: 'cover', display: 'block' }}
        />
      )}
      <Box sx={{ px: 1.25, py: 1 }}>
        <Typography sx={{ fontSize: '0.68rem', color: '#8696a0', textTransform: 'uppercase' }}>
          {preview.site_name || hostname}
        </Typography>
        {preview.title && (
          <Typography
            sx={{
              fontSize: '0.82rem',
              fontWeight: 600,
              color: '#111b21',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {preview.title}
          </Typography>
        )}
        {preview.description && (
          <Typography
            sx={{
              fontSize: '0.75rem',
              color: '#667781',
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              mt: 0.25,
            }}
          >
            {preview.description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
